import { QK } from 'ck-queries';
import { TargetGroupsResponse } from './types';
import { fetchWithErrorThrowing } from 'ck-utils';
import { useQuery } from '@tanstack/react-query';

// Query hook
export const useQueryTargetGroupsAudienceCount = (
  divisionName: string | null
) =>
  useQuery({
    queryKey: [QK.targetGroupsAudienceCount, divisionName],
    queryFn: () => getTargetGroupsAudienceCount(divisionName),
  });

// Query function
const getTargetGroupsAudienceCount = (divisionName: string | null) =>
  fetchWithErrorThrowing(
    `/target-groups/audience-count?divisionName=${divisionName}`,
    {
      method: 'GET',
    }
  )
    .then((res) => res.json())
    .then(({ targetGroups }: TargetGroupsResponse) => targetGroups);
